export default {
  get(key: string): string {
    return process.env[`VUE_APP_${key}`] as string
  },
}
